var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useMemo } from 'react';
import { Box, Typography, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TableSortLabel, Pagination, Chip, Tooltip, } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAlertsDashboard } from '../AlertsDashboard.action';
import { hideApplicationLoader, showApplicationLoader } from 'common/ApplicationLoader';
import DeviceStatusDetailsDialog from 'common/Dialogs/DeviceStatusDetailsDialog';
import WatchIcon from '@mui/icons-material/Watch';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import BedIcon from '@mui/icons-material/Bed';
import CircleIcon from '@mui/icons-material/Circle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from 'moment';
var categoryColors = {
    high: '#dc2626', // Red
    moderate: '#f59e0b', // Yellow
    stable: '#16a34a', // Green
    default: '#6b7280',
};
var riskCategoryOrder = {
    high: 0,
    moderate: 1,
    stable: 2,
};
var getCategoryColor = function (category) {
    return categoryColors[(category || '').toLowerCase()] ||
        categoryColors.default;
};
var getMetricPercentage = function (value) {
    return Math.max(0, Math.min(100, value < 0 ? ((value + 100) / 50) * 100 : value));
};
var categoricalBatteryPercentages = {
    high: 100,
    medium: 75,
    low: 30,
};
var getBatteryPercentage = function (value) {
    if (value == null || value === '')
        return undefined;
    var numericValue = Number(value);
    if (Number.isFinite(numericValue))
        return getMetricPercentage(numericValue);
    return categoricalBatteryPercentages[String(value).toLowerCase()];
};
var BatteryLevel = function (_a) {
    var value = _a.value, batteryVoltage = _a.batteryVoltage, _b = _a.useDeviceThresholds, useDeviceThresholds = _b === void 0 ? false : _b;
    if (value == null || value === '') {
        return (_jsxs("span", { children: ["-", batteryVoltage != null ? " (".concat(batteryVoltage, " mV)") : ''] }));
    }
    var isCategorical = typeof value === 'string' && !Number.isFinite(Number(value));
    if (isCategorical && !useDeviceThresholds) {
        return (_jsxs(Typography, { component: 'span', sx: { fontSize: 11, color: '#374151' }, children: [value, batteryVoltage != null ? " (".concat(batteryVoltage, " mV)") : ''] }));
    }
    var percentage = getBatteryPercentage(value);
    if (percentage == null && !useDeviceThresholds)
        return _jsx("span", { children: "-" });
    var category = String(value).toLowerCase();
    var color = useDeviceThresholds
        ? isCategorical
            ? category === 'high'
                ? '#16a34a'
                : category === 'low'
                    ? '#ef4444'
                    : '#e9a400'
            : percentage < 30
                ? '#ef4444'
                : percentage <= 75
                    ? '#e9a400'
                    : '#16a34a'
        : percentage <= 20
            ? '#ef4444'
            : percentage <= 60
                ? '#e9a400'
                : '#16a34a';
    var fillPercentage = isCategorical
        ? category === 'high'
            ? 100
            : category === 'medium'
                ? 50
                : category === 'low'
                    ? 20
                    : 0
        : percentage !== null && percentage !== void 0 ? percentage : 0;
    return (_jsxs(Box, { component: 'span', role: 'img', "aria-label": "Battery ".concat(isCategorical ? value : "".concat(percentage, "%")).concat(batteryVoltage != null ? " (".concat(batteryVoltage, " mV)") : ''), title: "Battery ".concat(isCategorical ? value : "".concat(percentage, "%")).concat(batteryVoltage != null ? " (".concat(batteryVoltage, " mV)") : ''), sx: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            gap: 0.6,
            verticalAlign: 'middle',
        }, children: [_jsxs(Box, { sx: {
                    position: 'relative',
                    width: 13,
                    height: 19,
                    border: "1.5px solid ".concat(color),
                    borderRadius: '2px',
                    p: '2px',
                    boxSizing: 'border-box',
                }, children: [_jsx(Box, { sx: {
                            position: 'absolute',
                            width: 5,
                            height: 2,
                            top: -4,
                            left: 2.5,
                            borderRadius: '1px 1px 0 0',
                            backgroundColor: color,
                        } }), _jsx(Box, { sx: {
                            position: 'absolute',
                            bottom: 2,
                            left: 2,
                            right: 2,
                            height: "".concat(fillPercentage, "%"),
                            maxHeight: 12,
                            backgroundColor: color,
                            borderRadius: '1px',
                        } })] }), _jsxs(Typography, { component: 'span', sx: { fontSize: 11, color: '#374151', whiteSpace: 'nowrap' }, children: [isCategorical ? value : "".concat(Math.round(percentage !== null && percentage !== void 0 ? percentage : 0), "%"), batteryVoltage != null ? " (".concat(batteryVoltage, " mV)") : ''] })] }));
};
var SignalLevel = function (_a) {
    var value = _a.value;
    if (value == null || value === '')
        return _jsx("span", { children: "-" });
    var signalStrength = Math.abs(Number(value));
    if (!Number.isFinite(signalStrength))
        return _jsx("span", { children: "-" });
    var status = signalStrength >= 61 && signalStrength <= 104
        ? 'high'
        : signalStrength >= 105 && signalStrength <= 120
            ? 'medium'
            : signalStrength >= 121 && signalStrength <= 140
                ? 'low'
                : undefined;
    var bars = status === 'high' ? 4 : status === 'medium' ? 2 : status === 'low' ? 1 : 0;
    var color = status === 'high'
        ? '#16a34a'
        : status === 'medium'
            ? '#e9a400'
            : status === 'low'
                ? '#ef4444'
                : '#9ca3af';
    var signalDescription = status
        ? "".concat(status, " signal, -").concat(signalStrength, " dBm")
        : "Signal -".concat(signalStrength, " dBm");
    return (_jsxs(Box, { component: 'span', role: 'img', "aria-label": signalDescription, title: signalDescription, sx: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.6,
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
        }, children: [_jsx(Box, { sx: { display: 'inline-flex', alignItems: 'flex-end', gap: '2px', height: 16 }, children: [6, 9, 12, 15].map(function (height, index) { return (_jsx(Box, { component: 'span', sx: { width: 3, height: height, borderRadius: '1px 1px 0 0', backgroundColor: index < bars ? color : '#d1d5db' } }, height)); }) }), _jsx(Typography, { component: 'span', sx: {
                    fontSize: 11,
                    color: color,
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                }, children: status || '-' })] }));
};
var AlertsDashboardPivot = function (_a) {
    var seniorsData = _a.seniorsData, loading = _a.loading, lastEvaluatedKey = _a.lastEvaluatedKey, allSeniorsChecked = _a.allSeniorsChecked, searchParams = _a.searchParams, handleAvatarClick = _a.handleAvatarClick;
    var dispatch = useDispatch();
    var _b = useState('risk_category'), orderBy = _b[0], setOrderBy = _b[1];
    var _c = useState('asc'), order = _c[0], setOrder = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState([null]), lastKeys = _e[0], setLastKeys = _e[1];
    var _f = useState(false), localLoading = _f[0], setLocalLoading = _f[1];
    var _g = useState(false), deviceDialogOpen = _g[0], setDeviceDialogOpen = _g[1];
    var _h = useState(null), selectedDeviceStatus = _h[0], setSelectedDeviceStatus = _h[1];
    var _j = useState(null), selectedDeviceMetrics = _j[0], setSelectedDeviceMetrics = _j[1];
    var _k = useState(null), expandedRow = _k[0], setExpandedRow = _k[1];
    var getStatusColor = function (status) {
        if (!status || status === '-' || status.toLowerCase() === 'na')
            return '#9ca3af'; // gray
        if (status.toLowerCase() === 'online')
            return '#16a34a'; // green
        if (status.toLowerCase() === 'offline')
            return '#dc2626'; // red
        return '#9ca3af'; // gray
    };
    var getStatusLabel = function (status) {
        if (!status || status === '-' || status.toLowerCase() === 'na')
            return 'Not Connected';
        return status.charAt(0).toUpperCase() + status.slice(1);
    };
    var getFormattedDate = function (date) {
        if (!date)
            return "Not Available";
        var cleaned = date
            .replace(/(\+\d{4})Z$/, function (_, tz) { return "+".concat(tz.slice(1, 3), ":").concat(tz.slice(3, 5)); })
            .replace(/(\+\d{2}:\d{2})Z$/, "$1");
        var parsed = moment.utc(cleaned);
        return parsed.isValid()
            ? parsed.format("MM/DD/YYYY HH:mm:ss")
            : "Not Available";
    };
    var getChipStyles = function (status) {
        var s = status === null || status === void 0 ? void 0 : status.toLowerCase();
        if (s === "online") {
            return { label: "Online", bg: "#dcfce7", color: "#166534", border: "1px solid #16a34a" };
        }
        if (s === "offline") {
            return { label: "Offline", bg: "#fee2e2", color: "#991b1b", border: "1px solid #dc2626" };
        }
        // No device connected or NA
        return { label: "No Device", bg: "#e5e7eb", color: "#374151", border: "1px solid #9ca3af" };
    };
    var openDevicePopup = function (senior) {
        setSelectedDeviceStatus((senior === null || senior === void 0 ? void 0 : senior.device_status) || {});
        setSelectedDeviceMetrics((senior === null || senior === void 0 ? void 0 : senior.devices) || {});
        setDeviceDialogOpen(true);
    };
    var handleSort = function (property) {
        var isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    var cleanName = function (name) { return name.replace(/\(\d+\)/g, '').trim(); };
    // ✅ Pagination handler
    var handlePageChange = function (_, newPage) { return __awaiter(void 0, void 0, void 0, function () {
        var keyToUse, params, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (newPage === page)
                        return [2 /*return*/];
                    setLocalLoading(true);
                    dispatch(showApplicationLoader());
                    keyToUse = null;
                    if (newPage > page)
                        keyToUse = lastEvaluatedKey !== null && lastEvaluatedKey !== void 0 ? lastEvaluatedKey : null;
                    else
                        keyToUse = (_a = lastKeys[newPage - 1]) !== null && _a !== void 0 ? _a : null;
                    params = __assign(__assign({}, searchParams), { last_evaluated_key: keyToUse });
                    return [4 /*yield*/, dispatch(getAlertsDashboard(params, allSeniorsChecked))];
                case 1:
                    result = _b.sent();
                    // If backend returned a new key, push it into lastKeys
                    if ((result === null || result === void 0 ? void 0 : result.lastEvaluatedKey) !== undefined) {
                        if (newPage === lastKeys.length) {
                            setLastKeys(function (prev) { var _a; return __spreadArray(__spreadArray([], prev, true), [(_a = result.lastEvaluatedKey) !== null && _a !== void 0 ? _a : null], false); });
                        }
                    }
                    setPage(newPage);
                    setLocalLoading(false);
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/];
            }
        });
    }); };
    // ✅ Unified sorting logic for all columns
    var sortedData = useMemo(function () {
        if (!seniorsData)
            return [];
        var getValue = function (senior, key) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
            switch (key) {
                case 'member_id':
                    return (_b = (_a = senior.profile) === null || _a === void 0 ? void 0 : _a.member_id) !== null && _b !== void 0 ? _b : '';
                case 'first_name': {
                    var name = cleanName(((_c = senior.profile) === null || _c === void 0 ? void 0 : _c.full_name) || senior.seniorName || '');
                    return name.split(' ')[0] || '';
                }
                case 'last_name': {
                    var name = cleanName(((_d = senior.profile) === null || _d === void 0 ? void 0 : _d.full_name) || senior.seniorName || '');
                    return name.split(' ').slice(1).join(' ') || '';
                }
                case 'status':
                    return (_g = (_f = (_e = senior.device_status) === null || _e === void 0 ? void 0 : _e.watch) === null || _f === void 0 ? void 0 : _f.status) !== null && _g !== void 0 ? _g : '-';
                case 'battery':
                    return Number((_j = (_h = senior.devices) === null || _h === void 0 ? void 0 : _h.watch) === null || _j === void 0 ? void 0 : _j.battery_percentage) || 0;
                case 'scale_battery':
                    return (_m = getBatteryPercentage((_l = (_k = senior.devices) === null || _k === void 0 ? void 0 : _k.scale) === null || _l === void 0 ? void 0 : _l.battery)) !== null && _m !== void 0 ? _m : 0;
                case 'sleep_mat_battery':
                    return (_q = getBatteryPercentage((_p = (_o = senior.devices) === null || _o === void 0 ? void 0 : _o.sleep_mat) === null || _p === void 0 ? void 0 : _p.battery)) !== null && _q !== void 0 ? _q : 0;
                case 'signal':
                    return Number((_s = (_r = senior.devices) === null || _r === void 0 ? void 0 : _r.watch) === null || _s === void 0 ? void 0 : _s.network_signal) || 0;
                case 'heart_rate':
                    return Number((_u = (_t = senior.devices) === null || _t === void 0 ? void 0 : _t.watch) === null || _u === void 0 ? void 0 : _u.heart_rate) || 0;
                case 'steps':
                    return Number((_w = (_v = senior.devices) === null || _v === void 0 ? void 0 : _v.watch) === null || _w === void 0 ? void 0 : _w.avg_activity_score) || 0;
                case 'weight':
                    return Number((_y = (_x = senior.devices) === null || _x === void 0 ? void 0 : _x.scale) === null || _y === void 0 ? void 0 : _y.avg_weight) || 0;
                case 'hydration':
                    return Number((_0 = (_z = senior.devices) === null || _z === void 0 ? void 0 : _z.scale) === null || _0 === void 0 ? void 0 : _0.avg_hydration) || 0;
                case 'sleep_score':
                    return Number((_2 = (_1 = senior.devices) === null || _1 === void 0 ? void 0 : _1.sleep_mat) === null || _2 === void 0 ? void 0 : _2.avg_sleep_score) || 0;
                case 'sleep_duration':
                    return Number((_4 = (_3 = senior.devices) === null || _3 === void 0 ? void 0 : _3.sleep_mat) === null || _4 === void 0 ? void 0 : _4.avg_total_sleep_time) || 0;
                case 'interruptions':
                    return Number((_6 = (_5 = senior.devices) === null || _5 === void 0 ? void 0 : _5.sleep_mat) === null || _6 === void 0 ? void 0 : _6.interruptions) || 0;
                case 'alerts_total':
                    return Number((((_7 = senior.alerts) === null || _7 === void 0 ? void 0 : _7.sos) || 0) + (((_8 = senior.alerts) === null || _8 === void 0 ? void 0 : _8.falls) || 0)) || 0;
                case 'risk_category':
                    return (senior.risk_category || senior.riskCategory || '').toLowerCase();
                default:
                    return '';
            }
        };
        return __spreadArray([], seniorsData, true).sort(function (a, b) {
            var _a, _b;
            var aVal = getValue(a, orderBy);
            var bVal = getValue(b, orderBy);
            if (orderBy === 'risk_category') {
                var aRank = (_a = riskCategoryOrder[String(aVal)]) !== null && _a !== void 0 ? _a : 3;
                var bRank = (_b = riskCategoryOrder[String(bVal)]) !== null && _b !== void 0 ? _b : 3;
                if (aRank !== bRank)
                    return order === 'asc' ? aRank - bRank : bRank - aRank;
            }
            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return order === 'asc' ? aVal - bVal : bVal - aVal;
            }
            return order === 'asc'
                ? String(aVal).localeCompare(String(bVal))
                : String(bVal).localeCompare(String(aVal));
        });
    }, [seniorsData, order, orderBy]);
    // ✅ Aggregation logic
    var aggregates = useMemo(function () {
        if (!(seniorsData === null || seniorsData === void 0 ? void 0 : seniorsData.length))
            return null;
        var numericValues = function (path) {
            return seniorsData
                .map(function (s) {
                var parts = path.split('.');
                var val = s;
                for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                    var p = parts_1[_i];
                    if (!val)
                        return null;
                    val = val[p];
                }
                var num = Number(val);
                return isNaN(num) ? null : num;
            })
                .filter(function (v) { return v !== null; });
        };
        var average = function (values) {
            return values.length
                ? (values.reduce(function (a, b) { return a + b; }, 0) / values.length).toFixed(1)
                : '-';
        };
        return {
            avgHeartRate: average(numericValues('devices.watch.heart_rate')),
            avgBattery: average(numericValues('devices.watch.battery_percentage')),
            avgScaleBattery: average(seniorsData
                .map(function (senior) { var _a, _b; return getBatteryPercentage((_b = (_a = senior.devices) === null || _a === void 0 ? void 0 : _a.scale) === null || _b === void 0 ? void 0 : _b.battery); })
                .filter(function (value) { return value != null; })),
            avgSleepMatBattery: average(seniorsData
                .map(function (senior) { var _a, _b; return getBatteryPercentage((_b = (_a = senior.devices) === null || _a === void 0 ? void 0 : _a.sleep_mat) === null || _b === void 0 ? void 0 : _b.battery); })
                .filter(function (value) { return value != null; })),
            avgSignal: average(numericValues('devices.watch.network_signal')),
            avgSteps: average(numericValues('devices.watch.avg_activity_score')),
            avgWeight: average(numericValues('devices.scale.avg_weight')),
            avgHydration: average(numericValues('devices.scale.avg_hydration')),
            avgSleepScore: average(numericValues('devices.sleep_mat.avg_sleep_score')),
            avgSleepDuration: average(numericValues('devices.sleep_mat.avg_total_sleep_time').map(function (v) { return v / 3600; })),
            avgInterruptions: average(numericValues('devices.sleep_mat.interruptions')),
            totalSOS: numericValues('alerts.sos').reduce(function (a, b) { return a + b; }, 0),
            totalFalls: numericValues('alerts.falls').reduce(function (a, b) { return a + b; }, 0),
        };
    }, [seniorsData]);
    // 🔥 Unified Device Status Logic (same as in SeniorCard)
    var getUnifiedDeviceState = function (deviceStatus) {
        if (deviceStatus === void 0) { deviceStatus = {}; }
        if (!deviceStatus || Object.keys(deviceStatus).length === 0) {
            return { state: "no-connection", color: "#9ca3af" };
        }
        var statuses = Object.values(deviceStatus).map(function (d) {
            return String((d === null || d === void 0 ? void 0 : d.status) || "-").toLowerCase();
        });
        var online = statuses.filter(function (s) { return s === "online"; }).length;
        var offline = statuses.filter(function (s) { return s === "offline"; }).length;
        var hyphen = statuses.filter(function (s) { return s === "-"; }).length;
        if (hyphen === statuses.length) {
            return { state: "no-connection", color: "#9ca3af" }; // ALL "-" → GRAY
        }
        if (online === statuses.length) {
            return { state: "green", color: "#16a34a" }; // ALL ONLINE → GREEN
        }
        if (online >= 1 && offline === 0) {
            return { state: "green", color: "#16a34a" }; // ONLINE + "-" → GREEN
        }
        if (offline >= 1 && online === 0) {
            return { state: "red", color: "#dc2626" }; // OFFLINE + "-" → RED
        }
        if (online >= 1 && offline >= 1) {
            return { state: "red", color: "#dc2626" }; // MIX → RED
        }
        return { state: "no-connection", color: "#9ca3af" };
    };
    if (loading || localLoading) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 250, children: _jsx(CircularProgress, { color: "primary" }) }));
    }
    if (!seniorsData || seniorsData.length === 0) {
        return (_jsx(Box, { textAlign: "center", p: 4, sx: {
                backgroundColor: '#fff', borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }, children: _jsx(Typography, { variant: "h6", sx: { color: '#37474f' }, children: "No Records Found" }) }));
    }
    return (_jsxs(Box, { children: [_jsx(TableContainer, { component: Paper, sx: {
                    borderRadius: 2, boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                    backgroundColor: '#fff', maxHeight: '70vh', overflowY: 'auto'
                }, children: _jsxs(Table, { stickyHeader: true, sx: {
                        '& .MuiTableCell-root': { padding: '4px 8px' }, // compact cells
                        '& .MuiTableRow-root': { height: '32px' }, // reduced row height
                    }, children: [_jsx(TableHead, { children: _jsx(TableRow, { sx: { backgroundColor: '#f1f5f9' }, children: [
                                    { key: 'risk_category', label: 'Risk Category' },
                                    { key: 'member_id', label: 'Member ID' },
                                    { key: 'first_name', label: 'First Name' },
                                    { key: 'last_name', label: 'Last Name' },
                                    { key: 'status', label: 'Device Status' },
                                    { key: 'battery', label: 'Watch Battery' },
                                    { key: 'scale_battery', label: 'Scale Battery' },
                                    { key: 'sleep_mat_battery', label: 'Sleep Mat Battery' },
                                    { key: 'signal', label: 'WatchSignal' },
                                    { key: 'heart_rate', label: 'Heart Rate (bpm)' },
                                    { key: 'steps', label: 'Activity Score' },
                                    { key: 'weight', label: 'Weight (lbs)' },
                                    { key: 'hydration', label: 'Hydration (%)' },
                                    { key: 'sleep_score', label: 'Sleep Score' },
                                    { key: 'sleep_duration', label: 'Sleep Duration (hrs)' },
                                    { key: 'interruptions', label: 'Interruptions' },
                                    { key: 'alerts_total', label: 'Alerts' },
                                ].map(function (column) { return (_jsx(TableCell, { children: _jsxs(Box, { sx: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 0.25,
                                        }, children: [_jsx(TableSortLabel, { active: orderBy === column.key, direction: orderBy === column.key ? order : 'asc', onClick: function () { return handleSort(column.key); }, children: _jsx("strong", { children: column.label }) }), ['battery', 'scale_battery', 'sleep_mat_battery', 'signal'].includes(column.key) && (_jsx(Tooltip, { arrow: true, title: _jsx(Typography, { sx: {
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                    }, children: column.key === 'signal'
                                                        ? 'High: 61-104 dBm | Medium: 105-120 dBm | Low: 121-140 dBm'
                                                        : 'High: >75% | Medium: >=30% - <=75% | Low: <30%' }), slotProps: {
                                                    tooltip: {
                                                        sx: {
                                                            maxWidth: 'none',
                                                            whiteSpace: 'nowrap',
                                                            fontSize: '13px',
                                                        },
                                                    },
                                                }, children: _jsx(InfoOutlinedIcon, { "aria-label": "".concat(column.label, " level thresholds"), sx: {
                                                        fontSize: 17,
                                                        color: '#fff',
                                                        cursor: 'help',
                                                        verticalAlign: 'middle',
                                                    } }) }))] }) }, column.key)); }) }) }), _jsxs(TableBody, { children: [sortedData.map(function (senior, index) {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
                                    var fullName = cleanName(((_a = senior.profile) === null || _a === void 0 ? void 0 : _a.full_name) || senior.seniorName || '');
                                    var _12 = fullName.split(' '), firstName = _12[0], lastNameParts = _12.slice(1);
                                    var lastName = cleanName(lastNameParts.join(' '));
                                    var heartRate = (_d = (_c = (_b = senior.devices) === null || _b === void 0 ? void 0 : _b.watch) === null || _c === void 0 ? void 0 : _c.heart_rate) !== null && _d !== void 0 ? _d : '-';
                                    var batteryPercentage = (_f = (_e = senior.devices) === null || _e === void 0 ? void 0 : _e.watch) === null || _f === void 0 ? void 0 : _f.battery_percentage;
                                    var batteryVoltage = (_h = (_g = senior.devices) === null || _g === void 0 ? void 0 : _g.watch) === null || _h === void 0 ? void 0 : _h.battery_voltage;
                                    var scaleBattery = (_k = (_j = senior.devices) === null || _j === void 0 ? void 0 : _j.scale) === null || _k === void 0 ? void 0 : _k.battery;
                                    var sleepMatBattery = (_m = (_l = senior.devices) === null || _l === void 0 ? void 0 : _l.sleep_mat) === null || _m === void 0 ? void 0 : _m.battery;
                                    var networkSignal = (_p = (_o = senior.devices) === null || _o === void 0 ? void 0 : _o.watch) === null || _p === void 0 ? void 0 : _p.network_signal;
                                    var steps = (_s = (_r = (_q = senior.devices) === null || _q === void 0 ? void 0 : _q.watch) === null || _r === void 0 ? void 0 : _r.avg_activity_score) !== null && _s !== void 0 ? _s : '-';
                                    var weight = (_v = (_u = (_t = senior.devices) === null || _t === void 0 ? void 0 : _t.scale) === null || _u === void 0 ? void 0 : _u.avg_weight) !== null && _v !== void 0 ? _v : '-';
                                    var hydration = (_y = (_x = (_w = senior.devices) === null || _w === void 0 ? void 0 : _w.scale) === null || _x === void 0 ? void 0 : _x.avg_hydration) !== null && _y !== void 0 ? _y : '-';
                                    var sleepScore = (_1 = (_0 = (_z = senior.devices) === null || _z === void 0 ? void 0 : _z.sleep_mat) === null || _0 === void 0 ? void 0 : _0.avg_sleep_score) !== null && _1 !== void 0 ? _1 : '-';
                                    var interruptions = (_4 = (_3 = (_2 = senior.devices) === null || _2 === void 0 ? void 0 : _2.sleep_mat) === null || _3 === void 0 ? void 0 : _3.interruptions) !== null && _4 !== void 0 ? _4 : '-';
                                    var totalSeconds = (_7 = (_6 = (_5 = senior.devices) === null || _5 === void 0 ? void 0 : _5.sleep_mat) === null || _6 === void 0 ? void 0 : _6.avg_total_sleep_time) !== null && _7 !== void 0 ? _7 : 0;
                                    var hours = Math.floor(totalSeconds / 3600);
                                    var minutes = Math.floor((totalSeconds % 3600) / 60);
                                    var sleepDuration = totalSeconds > 0 ? "".concat(hours, "h ").concat(minutes, "m") : '-';
                                    var sos = ((_8 = senior.alerts) === null || _8 === void 0 ? void 0 : _8.sos) || "-";
                                    var falls = ((_9 = senior.alerts) === null || _9 === void 0 ? void 0 : _9.falls) || "-";
                                    var unifiedStatus = getUnifiedDeviceState(senior.device_status);
                                    return (_jsxs(React.Fragment, { children: [_jsxs(TableRow, { sx: {
                                                    '&:hover': { backgroundColor: '#f5f5f5' },
                                                    cursor: "pointer"
                                                }, onClick: function () { return handleAvatarClick === null || handleAvatarClick === void 0 ? void 0 : handleAvatarClick(senior); }, children: [_jsx(TableCell, { children: _jsx(Chip, { label: senior.risk_category || 'No Data', sx: {
                                                                fontWeight: 600,
                                                                textTransform: 'capitalize',
                                                                color: '#fff',
                                                                backgroundColor: getCategoryColor(senior.risk_category),
                                                            }, size: "small" }) }), _jsx(TableCell, { children: (_11 = (_10 = senior.profile) === null || _10 === void 0 ? void 0 : _10.member_id) !== null && _11 !== void 0 ? _11 : '-' }), _jsx(TableCell, { children: firstName || '-' }), _jsx(TableCell, { children: lastName || '-' }), _jsx(TableCell, { children: _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [unifiedStatus.state !== "no-connection" && (_jsx(Box, { sx: {
                                                                        width: 18,
                                                                        height: 18,
                                                                        borderRadius: "50%",
                                                                        border: "1px solid #475569",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                        fontSize: 12,
                                                                        "&:hover": { backgroundColor: "#e2e8f0" },
                                                                    }, onClick: function (e) {
                                                                        e.stopPropagation();
                                                                        var isExpanding = expandedRow !== index;
                                                                        setExpandedRow(isExpanding ? index : null);
                                                                    }, children: expandedRow === index ? "-" : "+" })), (function () {
                                                                    var chipStyles = {
                                                                        green: {
                                                                            label: "Online", bg: "#dcfce7",
                                                                            color: "#166534", border: "1px solid #16a34a"
                                                                        },
                                                                        red: {
                                                                            label: "Offline", bg: "#fee2e2",
                                                                            color: "#991b1b", border: "1px solid #dc2626"
                                                                        },
                                                                        "no-connection": {
                                                                            label: "No Device", bg: "#e5e7eb",
                                                                            color: "#374151", border: "1px solid #9ca3af"
                                                                        },
                                                                    };
                                                                    var chip = chipStyles[unifiedStatus.state];
                                                                    return (_jsx(Chip, { label: chip.label, size: "small", sx: {
                                                                            backgroundColor: chip.bg,
                                                                            color: chip.color,
                                                                            border: chip.border,
                                                                            fontWeight: 600,
                                                                            height: 22,
                                                                            cursor: 'pointer',
                                                                        }, onClick: function (event) {
                                                                            event.stopPropagation();
                                                                            openDevicePopup(senior);
                                                                        } }));
                                                                })()] }) }), _jsx(TableCell, { sx: { whiteSpace: 'nowrap' }, children: _jsx(BatteryLevel, { value: batteryPercentage, batteryVoltage: batteryVoltage }) }), _jsx(TableCell, { children: _jsx(BatteryLevel, { value: scaleBattery, useDeviceThresholds: true }) }), _jsx(TableCell, { children: _jsx(BatteryLevel, { value: sleepMatBattery, useDeviceThresholds: true }) }), _jsx(TableCell, { children: _jsx(SignalLevel, { value: networkSignal }) }), _jsx(TableCell, { children: heartRate }), _jsx(TableCell, { children: steps }), _jsx(TableCell, { children: weight }), _jsx(TableCell, { children: hydration }), _jsx(TableCell, { children: sleepScore }), _jsx(TableCell, { children: sleepDuration }), _jsx(TableCell, { children: interruptions }), _jsx(TableCell, { children: "SOS: ".concat(sos, " | Falls: ").concat(falls) })] }, index), expandedRow === index && (_jsx(TableRow, { children: _jsxs(TableCell, { colSpan: 17, sx: { backgroundColor: '#f8fafc', p: 1 }, children: [['watch', 'scale', 'sleep_mat'].map(function (key) {
                                                            var _a;
                                                            var device = (_a = senior.device_status) === null || _a === void 0 ? void 0 : _a[key];
                                                            var statusValue = (device === null || device === void 0 ? void 0 : device.status) || '-';
                                                            var statusLabel = getStatusLabel(statusValue);
                                                            var color = getStatusColor(statusValue);
                                                            return (_jsxs(Box, { sx: {
                                                                    pb: 1,
                                                                    borderBottom: '1px solid #e2e8f0',
                                                                    backgroundColor: '#eff6ff',
                                                                }, children: [_jsxs(Box, { sx: {
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            mb: 0.5,
                                                                        }, children: [_jsxs(Box, { sx: {
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: 0.5,
                                                                                }, children: [key === 'watch' && (_jsx(WatchIcon, { sx: { fontSize: 18 } })), key === 'scale' && (_jsx(MonitorWeightIcon, { sx: { fontSize: 18 } })), key === 'sleep_mat' && (_jsx(BedIcon, { sx: { fontSize: 18 } })), _jsx(Typography, { sx: { fontWeight: 600 }, children: key === 'watch'
                                                                                            ? 'Watch'
                                                                                            : key === 'scale'
                                                                                                ? 'Scale'
                                                                                                : 'Sleep Mat' })] }), _jsxs(Box, { sx: {
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: 0.5,
                                                                                }, children: [_jsx(Typography, { sx: { fontSize: '0.85rem', fontWeight: 600 }, children: statusLabel }), _jsx(CircleIcon, { sx: { fontSize: 10, color: color } })] })] }), _jsxs(Typography, { sx: { fontSize: '0.75rem', color: '#64748b' }, children: [_jsx("strong", { children: "Last Measurement Taken :" }), getFormattedDate(device === null || device === void 0 ? void 0 : device.last_ingestion_date)] }), _jsxs(Typography, { sx: { fontSize: '0.75rem', color: '#64748b' }, children: [_jsx("strong", { children: "Last Connected:" }), getFormattedDate(device === null || device === void 0 ? void 0 : device.last_session_date)] })] }, key));
                                                        }), _jsxs(Box, { sx: {
                                                                mt: 2,
                                                                p: 1.5,
                                                                backgroundColor: '#f8fafc',
                                                                borderRadius: 2,
                                                                border: '1px solid #e2e8f0',
                                                            }, children: [_jsxs(Typography, { sx: {
                                                                        fontSize: '0.75rem',
                                                                        color: '#475569',
                                                                        lineHeight: 1.4,
                                                                        mb: 0.5,
                                                                    }, children: [_jsx("strong", { children: "Last Measurement Taken:" }), "Timestamp (UTC) of last data ingestion into ClearWellness platform."] }), _jsxs(Typography, { sx: {
                                                                        fontSize: '0.75rem',
                                                                        color: '#475569',
                                                                        lineHeight: 1.4,
                                                                    }, children: [_jsx("strong", { children: "Last Connected:" }), " Timestamp (UTC) of last device sync with vendor cloud."] })] })] }) }))] }, index));
                                }), aggregates && (_jsxs(TableRow, { sx: {
                                        backgroundColor: '#eef2ff',
                                        fontWeight: 700,
                                        position: 'sticky',
                                        bottom: 0,
                                    }, children: [_jsx(TableCell, { colSpan: 5, children: _jsx(Box, { sx: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    lineHeight: '1.2',
                                                }, children: _jsx("span", { children: _jsx("strong", { children: "Average/Total:" }) }) }) }), _jsx(TableCell, { children: aggregates.avgBattery }), _jsx(TableCell, { children: aggregates.avgScaleBattery }), _jsx(TableCell, { children: aggregates.avgSleepMatBattery }), _jsx(TableCell, { children: aggregates.avgSignal }), _jsx(TableCell, { children: aggregates.avgHeartRate }), _jsx(TableCell, { children: aggregates.avgSteps }), _jsx(TableCell, { children: aggregates.avgWeight }), _jsx(TableCell, { children: aggregates.avgHydration }), _jsx(TableCell, { children: aggregates.avgSleepScore }), _jsx(TableCell, { children: aggregates.avgSleepDuration }), _jsx(TableCell, { children: aggregates.avgInterruptions }), _jsxs(TableCell, { sx: { fontWeight: 700 }, children: ["SOS: ", aggregates.totalSOS, " | Falls: ", aggregates.totalFalls] })] }))] })] }) }), _jsxs(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, children: [_jsx(Pagination, { count: lastKeys.length, page: page, onChange: handlePageChange, shape: 'rounded', color: 'primary' }), _jsx(DeviceStatusDetailsDialog, { open: deviceDialogOpen, onClose: function () { return setDeviceDialogOpen(false); }, deviceStatus: selectedDeviceStatus || {}, deviceMetrics: selectedDeviceMetrics || {} })] })] }));
};
export default AlertsDashboardPivot;
